module.exports = __webpack_public_path__ + "media/assets/images/flags/kg-e20a842c75deb0c1a3bcd220b26f326c.svg";